import { useQuery } from "@tanstack/react-query";
import { useInitialVisitStore } from "../stores/initialVisitStore";
import { DateTime } from "luxon";

export type InitialVisitBooking = {
  organization: {
    name: string;
    phoneNumber: string;
    timezone: string;
    location: string;
    logoUrl: string;
  };
  appointment: {
    name: string;
    duration: number;
  };
};

type InitialVisitAvailabilityParams = {
  uniqueId?: string;
  enabled: boolean;
};

export function useInitialVisitAvailability({
  uniqueId,
  enabled = true
}: InitialVisitAvailabilityParams) {
  const { visibleMonth } = useInitialVisitStore();

  const currentDate = DateTime.now().startOf("day");

  const startDate = (
    currentDate.hasSame(visibleMonth, "month")
      ? currentDate
      : visibleMonth.startOf("month")
  ).toFormat("yyyy-MM-dd");
  const endDate = visibleMonth.endOf("month").toFormat("yyyy-MM-dd");

  return useQuery({
    queryKey: ["initial-visit-availability", uniqueId, startDate, endDate],
    queryFn: async () => {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/bookings/initial-visit/availability?uniqueId=${uniqueId}&startDate=${startDate}&endDate=${endDate}`,
        {
          method: "GET"
        }
      );
      if (response.status !== 200) {
        if (
          response.status === 404 ||
          response.status === 400 ||
          response.status === 410
        ) {
          throw new Error((await response.json()).message);
        } else {
          throw new Error("Error loading appointment availability");
        }
      }
      return response.json();
    },
    retry: false,
    staleTime: 1000 * 60 * 5, // cache for 5 minutes
    enabled
  });
}
